import { IconProps } from './types';

export const iconDefaultProps: IconProps = {
  $size: 16,
  $color: 'black',
  $display: 'inline-flex',
};
